import SocAiAgentComponent from './socaiAgent/SocAiAgent';

// Named export for compatibility with existing imports
export const SocAiAgent = SocAiAgentComponent;

// Default export for new imports
export default SocAiAgentComponent;